import { Message } from 'element-ui'

const state = {   //要设置的全局访问的state对象
    cityName: '',
    cityPoint: null,
};
const getters = {   //实时监听state值的变化(最新状态)
    //高德定位
    /*
    getCityInfo(callback) {
        if( state.cityName ){
            return state.cityName;
        }
        let find = (callback)=>{
            var citysearch = new AMap.CitySearch();
            citysearch.getLocalCity(function(status, result) {
                if (status === 'complete' && result.info === 'OK') {
                    if (result && result.city && result.bounds) {
                        var cityName = result.city.replace(/市$/,'');
                        var citybounds = result.bounds;
                        //map.setBounds(citybounds);//地图显示当前城市
                        state.cityName = cityName;
                        console.log(majorName);
                        if( typeof(callback)==='function' ){
                            callback(cityName);
                        }
                    }
                } else {
                    console.log(status,result);
                    Message(result.info);   
                }
            });
        }
        return find;
    },
    */
    //百度定位
    baiduLocation(){
        if( state.cityName ){
            return state.cityName;
        }
        let find = (callback)=>{
            // 百度地图API功能
            var geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(function(r){
                if(this.getStatus() == BMAP_STATUS_SUCCESS){
                    var mk = new BMap.Marker(r.point);
                    var cityName = r.address.city.replace(/市$/,'');
                    state.cityName = cityName;
                    state.cityPoint = r.point;
                    var cityInfo = {
                        cityName: cityName,
                        cityPoint: r.point,
                    }
                    localStorage.setItem('cityInfo',JSON.stringify(cityInfo));
                    console.log('百度地图定位成功：'+cityName);
                    if( typeof(callback)==='function' ){
                        callback(cityName);
                    }
                }
                else {
                    Message('failed'+this.getStatus());  
                }        
            },{enableHighAccuracy: true})
        }
        return find;
    },

    //从localStorage中获取定位信息
    getCityInfoFromStorage(){
        if( localStorage.cityInfo ){
            var cityInfo = JSON.parse(localStorage.getItem('cityInfo'))
            return cityInfo;
        }
        return ;
    },

};
const mutations = {
};
const actions = {
};

export default {
    namespaced: true, //用于在全局引用此文里的方法时标识这一个的文件名
    state,
    getters,
    mutations,
    actions
}